import script from "./BombasView.vue?vue&type=script&setup=true&lang=js"
export * from "./BombasView.vue?vue&type=script&setup=true&lang=js"

import "./BombasView.vue?vue&type=style&index=0&id=e5a7ed48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5a7ed48"]])

export default __exports__